import { Component, EventEmitter, Input, Optional, Output, Self } from '@angular/core';
import { ControlValueAccessor, NgControl, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
	selector: 'app-slider-toggle-input',
	templateUrl: './slider-toggle-input.component.html',
	standalone: true,
	imports: [MatSlideToggleModule, FormsModule, MatFormFieldModule],
})
export class SliderToggleInputComponent implements ControlValueAccessor {
	@Input({ required: false }) public value = false;
	@Input({ required: false }) public disabled = false;
	@Input({ required: false }) public label = '';
	@Output() valueChanged = new EventEmitter<boolean>();

	onChange?: (value: unknown) => void;
	onTouched?: CallableFunction;

	constructor(@Optional() @Self() public ngControl: NgControl) {
		if (this.ngControl != null) this.ngControl.valueAccessor = this;
	}

	changeValue(event: MatSlideToggleChange) {
		this.value = event.checked;
		this.valueChanged.emit(event.checked);
	}

	registerOnChange(fn: typeof this.onChange): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: CallableFunction): void {
		this.onTouched = fn;
	}

	writeValue(value: boolean): void {
		this.value = value ?? '';
	}
}
